import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    ReactNode,
} from "react";
import {BASE_URLS} from "../config/urls";
import {Person} from "../models/Person";

type AuthContextValue = {
    isAuth: boolean;
    roles: any[];
    isAdmin: boolean;
    loading: boolean;   // ← новое
    login: (roles: string[]) => void;
    logout: () => void;
    person: Person | null;
};


const AuthContext = createContext<AuthContextValue | undefined>(undefined);

type AuthProviderProps = {
    children: ReactNode;
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const [isAuth, setIsAuth] = useState<boolean>(false);
    const [roles, setRoles] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [person, setPerson] = useState<Person | null>(null);

    const isAdmin = roles.some(r => r.name === "ROLE_ADMIN");

    // 🎯 Проверка авторизации строго через бекенд
    const fetchUser = async () => {
        try {
            const resp = await fetch(`${BASE_URLS.api}/personal_account`, {
                method: "GET",
                credentials: "include",
                headers: { Accept: "application/json"}
            });

            if (resp.ok) {
                const data = await resp.json();
                const userRoles: string[] = data.roles || [];

                setPerson(data);
                setIsAuth(true);
                setRoles(userRoles);
            } else {
                // не авторизован
                setPerson(null);
                setIsAuth(false);
                setRoles([]);
            }
        } catch (e) {
            console.error("Ошибка /personal_account:", e);
            setPerson(null);
            setIsAuth(false);
            setRoles([]);
        } finally {
            setLoading(false);
        }
    };

    // 🔥 при старте приложения — сразу проверяем бекенд
    useEffect(() => {
        fetchUser();
    }, []);

    // вызывается после успешного логина (респонс от бека)
    const login = (roles: string[]) => {
        setIsAuth(true);
        setRoles(roles);
    };

    const logout = () => {
        setIsAuth(false);
        setRoles([]);
    };

    return (
        <AuthContext.Provider
            value={{
                isAuth,
                roles,
                isAdmin,
                loading,
                login,
                logout,
                person,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextValue => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used within AuthProvider");
    }
    return ctx;
};
